import React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import CustomTheme from "./component/ChakraStyle/theme";
import ReactDom from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./Store/data";
const container = document.getElementById("root");
const createRoot = ReactDom.render(
  <Provider store={store}>
    <ChakraProvider theme={CustomTheme}>
      <App></App>
    </ChakraProvider>
  </Provider>,
  container
);
